import React, { Component } from "react";
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';


import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSort,
    faSortAlphaDown,
    faSortAlphaUpAlt,
    faSortNumericDown,
    faSortNumericUpAlt
} from "@fortawesome/free-solid-svg-icons";

import {
    GetDiagnosticReportSort,
    ExportDiagnostic
} from '../../actions/diagnosticReportAction';

import { currentScrollingPage } from "../../constants/index";

import DiagnosticFiltersDrawer from "../../views/community/DiagnosticFiltersDrawer";

export class ManagementDiagnosticReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            diagnosticReports: this.props.tableData ? this.props.tableData : [],
            currentPage: currentScrollingPage,
            filterObj: undefined,
            openFilters: false,
            AnchorElId: undefined,
            community: props.communityInfo,
            sortColumn: 'lowerName',
            sortDesc: true
        };

        this.observer = React.createRef();
        this.lastDiagnosticRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }), async () => {
                        await this.props.GetDiagnosticReportSort(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
                    });
                }
            });
            if (node) this.observer.current.observe(node)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.communityInfo) {
            let communityId = this.state.community ? this.state.community._id : undefined;
            if (communityId === undefined || communityId !== nextProps.communityInfo._id) {
                this.setState(
                    {
                        community: nextProps.communityInfo,
                        filterObj: undefined,
                        selectedDevices: [],
                        selectAllButton: false,
                        openFilters: false,
                        AnchorElId: undefined
                    }, () => {
                        this.props.GetDiagnosticReportSort(nextProps.communityInfo.communityId, 0, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
                    }
                );
            }
        }
    }

    componentDidMount() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
        this.props.GetDiagnosticReportSort(communityId, this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
    }

    onFilterChange = (filterObj) => {
        const community = localStorage.getItem('communityId');

        if (filterObj) {

            this.setState({
                filterObj: filterObj,
                currentPage: 0,
                selectedDevices: [],
                selectAllButton: false,
                openFilters: false,
                AnchorElId: undefined
            }, () => {
                this.props.GetDiagnosticReportSort(community, this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
            });
        }

    }

    handleSort = (column) => {

        const currentColumn = this.state.sortColumn;

        const updState = {
            sortColumn: currentColumn,
            sortDesc: this.state.sortDesc,
            currentPage: 0,
            filtersApplied: true
        }

        if (currentColumn !== column) {
            updState.sortColumn = column
            updState.sortDesc = true;
        } else {
            updState.sortDesc = !this.state.sortDesc
        }

        this.setState(updState, async () => {
            await this.props.GetDiagnosticReportSort(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
        });
    }

    exportDiagnostic = () => {
        try {
            const communityInfo = this.state.community;

            this.props.ExportDiagnostic(localStorage.getItem('communityId'), communityInfo.name, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
        } catch (err) {
            return undefined
        }
    }

    render() {
        const currentData = this.props.tableData && Array.isArray(this.props.tableData) ? this.props.tableData : [];
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        return (
            <>
                <div className="activityTitle-engage">
                    <form >
                        <div id="export_diagnostic_btn" style={{ display: 'none' }}
                            onClick={this.exportDiagnostic}>
                            Export
                        </div>
                        {
                            ///Device List
                            <Grid container className="activityTitle-engage">
                                {/* Search and filters menu */}
                                <Grid item container xs={12} justifyContent='flex-end' alignItems='center'>
                                    <IconButton item onClick={(e) => this.setState({ openFilters: true, AnchorElId: 'filters_diag_btn' })} id='filters_diag_btn'>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/LegacyIcons/filter.svg'
                                            alt='filters_icon'
                                            width='30px'
                                            heigth='30px'
                                        />
                                    </IconButton>
                                </Grid>
                                <Grid container>
                                    <Grid container className='LGridColumnTitle LGridColumnTitleDiag' justifyContent='center' alignItems='center' style={{ flexGrow: 1, display: displayHeaders }} >
                                        <Grid item md={2} style={{}} id='addEditDevice_Headers_Resident'>
                                            Resident
                                            <IconButton onClick={() => this.handleSort('residentName')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'residentName' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'residentName' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'residentName') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={2} style={{}} id='addEditDevice_Headers_Device'>
                                            Device
                                            <IconButton onClick={() => this.handleSort('deviceId')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'deviceId' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'deviceId' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'deviceId') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={2} style={{}} id='addEditDevice_Headers_SerialNumber'>
                                            Serial
                                            <IconButton onClick={() => this.handleSort('serial')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'serial' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'serial' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'serial') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_Date'>
                                            Date
                                            <IconButton onClick={() => this.handleSort('createdAt')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'createdAt' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'createdAt' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'createdAt') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_MeasuringL'>
                                            Measuring L
                                            <IconButton onClick={() => this.handleSort('measuringLowestVal')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'measuringLowestVal' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'measuringLowestVal' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'measuringLowestVal') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_MeasuringH'>
                                            Measuring H
                                            <IconButton onClick={() => this.handleSort('measuringHighestVal')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'measuringHighestVal' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'measuringHighestVal' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'measuringHighestVal') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_Download'>
                                            Download
                                            <IconButton onClick={() => this.handleSort('downloadSpeedTest')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'downloadSpeedTest' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'downloadSpeedTest' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'downloadSpeedTest') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_Upload'>
                                            Upload
                                            <IconButton onClick={() => this.handleSort('uploadSpeedTest')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'uploadSpeedTest' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'uploadSpeedTest' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'uploadSpeedTest') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={1} style={{}} id='addEditDevice_Headers_signalStrength'>
                                            Signal Str
                                            <IconButton onClick={() => this.handleSort('signalStrength')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'signalStrength' && this.state.sortDesc) ? faSortNumericDown : (this.state.sortColumn === 'signalStrength' && !this.state.sortDesc) ? faSortNumericUpAlt : (this.state.sortColumn !== 'signalStrength') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                    <Grid container  >
                                        {
                                            currentData.map((item, index) => {
                                                let dCreatedAt = new Date(item.createdAt);

                                                let signalStrengthstr = "";
                                                switch (item.signalStrength) {
                                                    case 4:
                                                        signalStrengthstr = "- Excellent"
                                                        break;
                                                    case 3:
                                                        signalStrengthstr = "- Good"
                                                        break;
                                                    case 2:
                                                        signalStrengthstr = "- Fair"
                                                        break;
                                                    case 1:
                                                        signalStrengthstr = "- Weak"
                                                        break;
                                                    case 0:
                                                        signalStrengthstr = "- No signal"
                                                        break;
                                                    default:
                                                        signalStrengthstr = "No information"
                                                        break;
                                                }

                                                return (
                                                    <Grid item container ref={(currentData.length === index + 1) ? this.lastDiagnosticRef : undefined} key={index} className='LDeviceCell' alignContent='center' style={{ backgroundColor: '#FAFAFA', padding: '5px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', textAlign: 'center' }}>
                                                        <Grid item container xs={12} sm={12} md={2} justifyContent='center' alignContent='center' style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }} >
                                                            <Grid item style={{ paddingLeft: '15px' }}>
                                                                {item.residentName}
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={2} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                { item.deviceId ?  item.deviceId.substring(9) : "No device"}
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={2} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                {item.serial}
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={1} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                {dCreatedAt.toLocaleDateString("en-US")}
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={1} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                {item.measuringLowestVal} dB
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={1} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                {item.measuringHighestVal} dB
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={1} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                {item.downloadSpeedTest} Mbps
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={1} alignContent='center' justifyContent='center'>
                                                            <Grid item>
                                                                {item.uploadSpeedTest} Mbps
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} sm={12} md={1} alignContent='left' justifyContent='left'>
                                                            <Grid item>
                                                                {item.signalStrength} {signalStrengthstr}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        }

                    </form>

                    {/* FILTERS MODAL */}
                    {
                        this.state.openFilters && this.state.AnchorElId ?
                            <DiagnosticFiltersDrawer
                                idAnchorEl={this.state.AnchorElId}
                                onClose={() => this.setState({ openFilters: false, AnchorElId: undefined })}
                                onFilterChange={this.onFilterChange}
                                isLegacy={true}
                                filterObj={this.state.filterObj ? this.state.filterObj : {}}
                            />
                            :
                            undefined
                    }


                </div>
            </>
        )
    }

}

function mapStateToProps(state) {

    const diagnosticData = (state.diagnosticReportReducer && state.diagnosticReportReducer.diagnosticData) ? [...state.diagnosticReportReducer.diagnosticData] : [];
    const total = (state.diagnosticReportReducer && state.diagnosticReportReducer.totalReports) ? state.diagnosticReportReducer.totalReports : 0;

    return {
        tableData: diagnosticData,
        total
    }
}


export default connect(mapStateToProps, { GetDiagnosticReportSort, ExportDiagnostic })(reduxForm({
    form: 'ManagementDiagnosticReport',
    enableReinitialize: true
})(ManagementDiagnosticReport));